import { Button, Col, DatePicker, Dropdown, Form, Row, Select, Tooltip } from 'antd';
import { useState, useEffect, useCallback } from 'react';

const TopUpFilters = (props) => {
    const { RangePicker } = DatePicker;
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm()
    useEffect(() => {
        form.setFieldsValue(props?.filterValues);
        if (props?.onloadGrid) {
            props.onloadGrid();
        }
    }, [props?.filterValues])
    const handleSearch = useCallback((values) => {
        setOpen(false);
        props?.filterObj(values);
    }, [props])
    const handleOpenChange = useCallback((nextOpen, info) => {
        if (info.source === 'trigger' || nextOpen) {
            setOpen(nextOpen);
        }
    }, [])
    const handleMenuClick = (e) => {
        if (e.key === '3') {
            setOpen(false);
        }
    };
    const clearRecords = useCallback(() => {
        props?.filterObj({ address: null, startDate: null, endDate: null });
        setOpen(false);
        form.resetFields()
    }, [props, form])

    const items = [
        {
            label:
                <Form className="grid-filter-form"
                    autoComplete="off"
                    onFinish={handleSearch}
                    form={form} >
                    <p className='filter-option-title'>Filter Options</p>
                    <Row gutter={16} className='filters-row'>
                        <Col sm={24} md={24} lg={24} xl={24} xxl={24}>
                            <Form.Item className='' label="Address" name="address">
                                <Select
                                    className=""
                                    placeholder={`Select Address`}
                                >
                                    {props?.addressLu?.map((item) => (
                                        <Option value={item?.name} key={item?.name}>{item?.name}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col sm={24} md={24} lg={24} xl={24} xxl={24}>
                            <Form.Item label="Select date" name="dateRange">
                                <RangePicker format="DD-MM-YYYY" /></Form.Item>
                        </Col>
                    </Row>
                    <div className='mt-2 md:flex justify-end gap-2 space-y-2 md:space-y-0'>
                        <Button className='cancel-btn' onClick={clearRecords} key="back">Clear</Button>
                        <Button className='primary-btn' type="primary" htmlType="submit">Search</Button>
                    </div>
                </Form>
            ,
            key: '1',
        },
    ];
    const handleToolBarActions = useCallback((action) => () => {
        if (action === 'exportexcel') {
            props?.handleExcelExport();
        }
    }, [props])
    return (
        <div className='flex gap-2 justify-end items-center mb-3 mt-3'>
            <Tooltip key={"Export Excel"} title={"Export Excel"}>
                <div
                    className="cursor-pointer"
                    onClick={handleToolBarActions("exportexcel")}
                >
                    <span
                        className={`icon lg excel-icon cursor-pointer`}
                    ></span>
                </div>
            </Tooltip>
            <Dropdown
                overlayClassName='filterdropdown-overlay'
                className='filter-dropdown'
                menu={{
                    items,
                    onClick: handleMenuClick,
                }}
                onOpenChange={handleOpenChange}
                open={open}
                trigger={'click'}
            >
                <a onClick={(e) => e.preventDefault()} className=''>
                    <Tooltip title='Filter'>   <span className='icon filter-icon-dropdown'></span></Tooltip>
                </a>
            </Dropdown>
        </div>

    )
}
export default TopUpFilters;